// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "../css/" + "styles" + "." + "fc01209abbae41b4c923" + ".css";
};